import styled from 'styled-components';
import { P } from '@workramp/ui';

export const IconWrapper = styled.div`
  margin-right: 8px;
`;

export const IconTextPairWrapper = styled.div<{ $selected: boolean }>`
  display: flex;
  align-items: center;
  background: ${({ theme, $selected }) => ($selected ? theme.colors.secondary[50] : 'none')};
`;

export const Text = styled(P)`
  color: ${({ theme }) => theme.colors.secondary[600]};

  ${IconTextPairWrapper}:hover & {
    color: ${({ theme }) => theme.colors.secondary[900]};
  }
`;
